import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React, { useEffect, useState } from 'react';
import axios from 'axios';
import clsx from 'clsx';
import colors from "../../utils/colors";
import InputTextInputOption from "../dynamicFormElements/InputTextInputOption";
import SelectInputOption from "../dynamicFormElements/SelectInputOption";
import Spinner from "../Spinner";
import WarningFilled from "../../icons/WarningFilled";


import Button from "../Button";
import { createStyles } from "./styles";

var ZipCode = function ZipCode(_ref)











{var _countiesOptions$2;var onUpdateValCallback = _ref.onUpdateValCallback,validationMessage = _ref.validationMessage,validationPassed = _ref.validationPassed,_ref$defaultZip = _ref.defaultZip,defaultZip = _ref$defaultZip === void 0 ? '' : _ref$defaultZip,_ref$defaultState = _ref.defaultState,defaultState = _ref$defaultState === void 0 ? '' : _ref$defaultState,_ref$defaultCounty = _ref.defaultCounty,defaultCounty = _ref$defaultCounty === void 0 ? '' : _ref$defaultCounty,zipOptionName = _ref.zipOptionName,stateOptionName = _ref.stateOptionName,countyOptionName = _ref.countyOptionName,_ref$editable = _ref.editable,editable = _ref$editable === void 0 ? true : _ref$editable,_ref$disabled = _ref.disabled,disabled = _ref$disabled === void 0 ? true : _ref$disabled;
  var defaultOption = [
  {
    value: defaultCounty,
    label: defaultCounty
  }];


  var _useState = useState(false),_useState2 = _slicedToArray(_useState, 2),loading = _useState2[0],setLoading = _useState2[1];
  var _useState3 = useState(defaultZip),_useState4 = _slicedToArray(_useState3, 2),zipId = _useState4[0],setZipId = _useState4[1];
  var _useState5 = useState(defaultState),_useState6 = _slicedToArray(_useState5, 2),state = _useState6[0],setState = _useState6[1];
  var _useState7 = useState(
    defaultCounty ? defaultOption : []),_useState8 = _slicedToArray(_useState7, 2),countiesOptions = _useState8[0],setCountiesOptions = _useState8[1];

  var _useState9 = useState(defaultCounty),_useState10 = _slicedToArray(_useState9, 2),selectedCountyValue = _useState10[0],setSelectedCountyValue = _useState10[1];
  var _useState11 = useState(false),_useState12 = _slicedToArray(_useState11, 2),hasBadZipCodeError = _useState12[0],setHasBadZipCodeError = _useState12[1];
  var _useState13 = useState(disabled),_useState14 = _slicedToArray(_useState13, 2),isDisabled = _useState14[0],setIsDisabled = _useState14[1];

  var classes = createStyles();
  var hasZipInvalidSymbols = /\D/g.test(zipId);
  var isZipFieldTouch = zipId.length > 0 && zipId.length < 5;
  var hasErrorWithZipCode = hasBadZipCodeError || hasZipInvalidSymbols || isZipFieldTouch;
  var errorStyles = hasErrorWithZipCode && classes.errorField;

  var createCountiesOptions = function createCountiesOptions(countiesList) {
    return _mapInstanceProperty(countiesList).call(countiesList, function (_ref2) {var name = _ref2.name;
      return { value: name, label: name };
    });
  };

  var requestZipCodeInfo = /*#__PURE__*/function () {var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(zipCode) {var _context, res;return _regeneratorRuntime.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.prev = 0;

              setLoading(true);_context2.next = 4;return (
                axios.get(_concatInstanceProperty(_context = "https://".concat(
                process.env.REACT_APP_API_BASE_URL, "/geo/Prod/zip/")).call(_context, zipCode)));case 4:res = _context2.sent;

              setState(res.data.state.id);
              setCountiesOptions(createCountiesOptions(res.data.counties));
              setHasBadZipCodeError(false);_context2.next = 13;break;case 10:_context2.prev = 10;_context2.t0 = _context2["catch"](0);

              setHasBadZipCodeError(true);case 13:_context2.prev = 13;

              setLoading(false);return _context2.finish(13);case 16:case "end":return _context2.stop();}}}, _callee, null, [[0, 10, 13, 16]]);}));return function requestZipCodeInfo(_x) {return _ref3.apply(this, arguments);};}();



  var cleanUpFunction = function cleanUpFunction() {
    setState('');
    setCountiesOptions([]);
    setSelectedCountyValue('');
  };

  useEffect(function () {
    if (zipId.length === 5 && !hasZipInvalidSymbols && !isDisabled) {
      requestZipCodeInfo(zipId);
    } else {
      setHasBadZipCodeError(false);
      cleanUpFunction();
    }
    // for unmounted component
    return cleanUpFunction;
  }, [zipId]);

  useEffect(function () {
    setZipId(defaultZip);
    setState(defaultState);
    setSelectedCountyValue(defaultCounty);
    setCountiesOptions(defaultOption);
  }, [editable]);

  // update components values
  useEffect(function () {var _countiesOptions$;
    var selectedCounty = selectedCountyValue || ((_countiesOptions$ = countiesOptions[0]) === null || _countiesOptions$ === void 0 ? void 0 : _countiesOptions$.value);
    onUpdateValCallback({ zipId: zipId, state: state, selectedCounty: selectedCounty });
  }, [zipId, state, selectedCountyValue, countiesOptions]);

  var makeComponentEditable = function makeComponentEditable() {
    setIsDisabled(false);
    setZipId('');
    cleanUpFunction();
  };

  return /*#__PURE__*/(
    React.createElement("div", { className: classes.zipCodeWrapper }, /*#__PURE__*/
    React.createElement("div", { className: classes.zipTopWrapper }, /*#__PURE__*/
    React.createElement(InputTextInputOption, {
      name: zipOptionName,
      id: zipOptionName,
      label: "Zip Code",
      value: zipId,
      width: "small",
      className: clsx(classes.zipCode, errorStyles),
      disabled: isDisabled,
      maxLength: 5,
      onChange: function onChange(e) {return setZipId(e.target.value);},
      validationPassed: validationPassed,
      validationMessage: validationMessage }), /*#__PURE__*/

    React.createElement(InputTextInputOption, {
      name: stateOptionName,
      id: stateOptionName,
      label: "State",
      value: state,
      width: "small",
      disabled: true }),

    editable && isDisabled && /*#__PURE__*/
    React.createElement(Button, {
      onClick: makeComponentEditable,
      type: "text",
      color: "primary",
      className: classes.editButton }, "Edit"),




    hasErrorWithZipCode && /*#__PURE__*/
    React.createElement("div", { className: classes.validationBlock }, /*#__PURE__*/
    React.createElement(WarningFilled, {
      color: colors.red[500],
      height: "1.2rem",
      className: classes.validationIcon }), /*#__PURE__*/

    React.createElement("span", { className: classes.errorMessage },
    hasBadZipCodeError && 'Invalid Zip Code',
    (hasZipInvalidSymbols || isZipFieldTouch) &&
    !hasBadZipCodeError &&
    'Zip Code should be 5 digits.'))), /*#__PURE__*/




    React.createElement(SelectInputOption, {
      name: countyOptionName,
      id: countyOptionName,
      label: "County",
      options: countiesOptions,
      value: selectedCountyValue || ((_countiesOptions$2 = countiesOptions[0]) === null || _countiesOptions$2 === void 0 ? void 0 : _countiesOptions$2.value),
      disabled: isDisabled,
      width: "large",
      onChange: function onChange(e) {return setSelectedCountyValue(e.target.value);} }),

    loading && /*#__PURE__*/
    React.createElement("div", { className: classes.spinnerWrapper }, /*#__PURE__*/
    React.createElement(Spinner, { size: "5rem" }))));




};

export default ZipCode;
//# sourceMappingURL=index.js.map